import React from 'react';
import CauseImage from './CauseImage';
import withAnimation from '../../../hooks/withAnimation';
import BookOnlineSection from '../BookOnlineSection';

export const causes = [
  {
    title: 'Muscle Strain',
    description: 'One of the most frequent causes of low back pain is muscle strain or overuse. Activities that involve lifting heavy objects, sudden movements, or poor posture can lead to strained muscles or ligaments in the lower back.',
  },
  {
    title: 'Herniated Or Bulging Discs',
    description: 'The spine is made up of intervertebral discs that act as cushions between the vertebrae. Over time, these discs can degenerate or herniate, causing pressure on the nearby nerves and resulting in pain.',
  },
  {
    title: 'Spinal Stenosis',
    description: 'Spinal stenosis is a condition where the spinal canal narrows, putting pressure on the spinal cord and nerves. This can lead to low back pain, as well as leg pain (sciatica).',
  },
  {
    title: 'Osteoarthritis',
    description: 'Wear and tear of the spinal joints leads to chronic pain in the lower back. This condition is also commonly known as Lumbar Spondylosis.',
  },
  {
    title: 'Scoliosis',
    description: 'Scoliosis is an abnormal curvature of the spine, which can lead to low back pain, especially in more severe cases.',
  },
];

const CausesSection = ({ causeImage, serviceName = "", causes = [] }) => {
  return (
    <section className="bg-gray-100 py-12">
      <div className="container mx-auto px-4 lg:px-0">
        <h2 className="text-3xl text-primary pb-4 font-bold text-center mb-8 lg:text-4xl">Causes of {serviceName}</h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Column: Cause Descriptions */}
          <div className="lg:order-1">
            {causes.map((cause, index) => (
              <div key={index} className="mb-8">
                <h3 className="text-2xl font-bold text-primary mb-2">{cause.title}</h3>
                <p className="text-gray-700 text-lg text-justify">{cause.description}</p>
              </div>
            ))}
          </div>

          {/* Right Column: Sticky Image */}
          <div className="lg:order-2">
            <div className="sticky top-20">
              <BookOnlineSection/>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default withAnimation(CausesSection);
